<template>
  <div class="invoiceHistory">
    <Nav :title="title"></Nav>
    <p class="tip" :class="{ isIosxTip: isiOSX }">
      发票将由服务商单独发送，请注意查收。
    </p>
    <div class="content" id="content" :class="{ isIosx: isiOSX }">
      <div class="loading" v-if="isLoad">
        <img src="./../../assets/takingCar/loading.gif" alt="" />
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="!isLoad">
        <van-list
          class="allList"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          finished-text="已加载完成～"
          @load="onLoad"
          :offset="10"
        >
          <div v-for="(i, index) in list" :key="index">
            <p class="orderStatus">{{ i.date }}</p>
            <div
              class="list"
              v-for="(item, j) in i.list"
              :key="j"
              @click="goToSeeDetail(item.id)"
            >
              <div>
                <p class="title">
                  <span v-if="item.invoice_type == 0">电子发票</span>
                  <span v-if="item.invoice_type == 1">纸质发票</span>

                  <span v-if="item.status == 2">申请中</span>
                  <span v-if="item.status == 3">已开票</span>
                  <span v-if="item.status == 4">开票失败</span>
                  <span v-if="item.status == 5">开票作废</span>
                </p>
                <p class="time">
                  <span>{{ item.created_at }}</span>
                </p>
                <div class="carhHistory">
                  <div class="carList">
                    <p
                      class="carName"
                      v-for="(catItem, index1) in item.pay_money_list"
                      :key="index1"
                    >
                      <img
                        src="./../../assets/takingCar/caocao.png"
                        alt
                        v-if="item.short_name == 'CaoCao'"
                      />
                      <img
                        src="./../../assets/takingCar/yangguang.png"
                        alt
                        v-if="item.short_name == 'YangGuang'"
                      />
                      {{ item.platform_name }}{{ catItem | moneyFormat }}元
                    </p>
                  </div>
                  <div class="total">
                    <span>合计</span>
                    <span class="money">{{ item.amount | moneyFormat }}</span>
                    <span>元</span>
                  </div>
                </div>
                <div
                  class="moneytip"
                  @click.stop="showMoneyTip"
                  v-if="item.short_name == 'YangGuang'"
                >
                  开票金额变少了
                  <img src="./../../assets/takingCar/moneytip.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="empty" v-if="list.length < 1 && !isLoad">
      <p class="emptyMsg">暂无历史信息~</p>
    </div>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "开具历史",
      isiOSX: false,
      //   下拉刷新
      isLoading: false, //加载中
      loading: false,
      finished: false,
      page: 1, //请求第几页
      total: 0, //总共的数据条数
      list: [
        // {
        //   time: "03月24日 10:15",
        //   status: 1,
        //   carList: [
        //     { carName: "易道打车", money: 27 },
        //     { carName: "曹操", money: 23 },
        //     { carName: "易道打车", money: 25 }
        //   ]
        // }
      ],
      isLoad: true,
    };
  },
  components: { Nav },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.getInvoiceList(0);
  },
  filters: {
    moneyFormat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
  },
  watch: {
    $route: "getPath",
  },
  methods: {
    // 加载更多
    onLoad() {
      // console.log("加载更多");
      this.page++;
      this.getInvoiceList(2);
    },
    // 下拉刷新
    onRefresh() {
      // console.log("下拉刷新");
      this.page = 1;
      // this.finished = true;
      this.getInvoiceList(1);
    },
    // 获取发票历史
    getInvoiceList(type) {
      if (type == 1) {
        this.$api
          .post("/taxis/member/invoice/history/list", {
            page: this.page,
          })
          .then((res) => {
            // console.log(res)
            this.list = res.data;
            this.isLoading = false;
            this.finished = false;
          });
      } else if (type == 2) {
        this.$api
          .post("/taxis/member/invoice/history/list", {
            page: this.page,
          })
          .then((res) => {
            // console.log(res)
            // 加载更多
            let rows = res.data; //请求返回当页的列表

            this.loading = false;
            this.total = res.total;

            if (rows == null || rows.length === 0) {
              // 加载结束
              this.finished = true;
              return;
            }
            // 将新数据与老数据进行合并
            this.list = this.list.concat(rows);
            //如果列表数据条数>=总条数，不再触发滚动加载
            if (this.list.length >= this.total) {
              this.finished = true;
            }
          });
      } else {
        // this.finished = true;
        this.$api
          .post("/taxis/member/invoice/history/list", {
            page: this.page,
          })
          .then((res) => {
            this.isLoad = false;
            // console.log(res)
            this.list = res.data;
          });
      }
    },
    // 查看详情
    goToSeeDetail(id) {
      // console.log("查看详情：" + id);
      this.$router.push({
        path: "/takingCar/historyDetails",
        query: {
          id: id,
        },
      });
    },
    // 发票金额为什么减少弹窗
    showMoneyTip() {
      this.$dialog
        .alert({
          message:
            "<p>根据阳光出行平台规定，费用中<span>除客运服务费之外</span>的费用（<span>如停车费和高速费等</span>）不支持开具电子发票。</p><p>若要开具该项费用的发票，您可以与司机师傅沟通，<span>自行保存纸质发票</span>。</p>",
          confirmButtonText: "知道了",
          confirmButtonColor: "#F9591B",
          messageAlign: "left",
          className: "dialog",
          allowHtml: true,
        })
        .then(() => {});
    },
  },
  mounted() {
     let winHeight = document.documentElement.clientHeight; //浏览器视口大小
    document.getElementById("content").style.height = winHeight - 90 + "px"; //调整框高度
  },
};
</script>

<style lang="less">
.dialog {
  .van-dialog__content {
    color: #333333;
    font-size: 14px;
    line-height: 23px;
    p {
      span {
        color: #f9591b;
      }
    }
    p:last-child {
      margin-top: 10px;
    }
  }
}
.invoiceHistory {
  min-height: 100%;
  background: #f5f6f7;
  .loading {
    width: 40%;
    margin: 0 auto;
    display: flex;
    height: 100%;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .tip {
    background: #fff7e4;
    color: #b78100;
    font-size: 13px;
    text-align: center;
    position: fixed;
    top: 70px;
    left: 0;
    height: 36px;
    line-height: 36px;
    width: 100%;
    z-index: 10;
  }
  .isIosxTip {
    top: 90px;
  }
  .content {
    margin: 0px 15px;
    padding-top: 106px;
    overflow: scroll;
    .orderStatus {
      color: #999999;
      font-size: 13px;
      height: 18px;
      line-height: 18px;
      margin: 20px 0 15px;
    }
    .list {
      background: #ffffff;
      padding: 19px 15px 5px;
      margin-bottom: 15px;
      border-radius: 5px;
      overflow: hidden;
      .moneytip {
        color: #b78100;
        font-size: 11px;
        line-height: 16px;
        float: right;
        padding-bottom: 10px;
        img {
          width: 11px;
          height: 11px;
          transform: translateY(1px);
        }
      }
      .title {
        overflow: hidden;
        span:nth-child(1) {
          float: left;
          font-size: 11px;
          line-height: 16px;
          padding: 4px 8px;
          background: #fff7e4;
          color: #b78100;
          border-radius: 2px;
        }
        span:nth-child(2) {
          float: right;
          font-size: 13px;
          line-height: 18px;
          color: #666666;
          background: url(./../../assets/takingCar/moreright.png) no-repeat
            center right;
          background-size: 8.5px;
          padding: 4px 10px;
        }
      }
      .time {
        font-size: 15px;
        line-height: 21px;
        color: #333333;
        font-weight: bolder;
        margin: 10px 0;
      }
      .carhHistory {
        position: relative;
        .carList {
          .carName {
            font-size: 13px;
            line-height: 18px;
            color: #333333;
            margin-bottom: 10px;
            img {
              width: 13px;
              height: 15.21px;
              transform: translateY(2.5px);
            }
          }
        }
        .total {
          position: absolute;
          bottom: -3px;
          right: 0px;
          span {
            color: #333333;
            font-size: 14px;
            line-height: 20px;
          }
          .money {
            font-size: 20px;
            font-weight: bolder;
          }
        }
      }
    }
  }
  .isIosx {
    margin: 0 15px;
    padding-top: 126px;
  }
  .empty {
    text-align: center;
    color: #999999;
    font-size: 17px;
    line-height: 24px;
    height: 24px;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
  }
}
</style>
